<!-- Zweck: Stellt die HTML-Struktur für shop dialogs customer special price list component im Frontend bereit. -->
@if (article) {
  <div>
    <h1 mat-dialog-title>
      <div style="float: left; padding: 10px 0">
        <svg-icon>sonderpreis</svg-icon>
        Kundensonderpreise bearbeiten
      </div>
      <div style="float: right; padding: 5px 0">
        <button mat-icon-button (click)="close()">
          <svg-icon>error-clean</svg-icon>
        </button>
      </div>
      <div style="clear: both"></div>
    </h1>
    <div mat-dialog-content style="min-height: 200px">
      <h3 style="margin-bottom: 20px">
        <view-field-value-render
          [nowrap]="false"
          [artikel]="article"
        [fieldname]="'pzn'"></view-field-value-render>
        -
        <view-field-value-render
          [nowrap]="false"
          [artikel]="article"
        [fieldname]="'bezeichnung'"></view-field-value-render>
      </h3>
      <div>
        <mat-checkbox [(ngModel)]="history" (change)="load()">Vergangenheitsdaten anzeigen</mat-checkbox>
      </div>
      @if (!(data|async)) {
        <div>
          <div style="text-align: center">
            <div style="display: inline-block">
              <div>
                <mat-spinner></mat-spinner>
              </div>
              <div>
                Lade...
              </div>
            </div>
          </div>
        </div>
      } @else {
        <table class="table table-striped table-hover">
          <tr>
            <th></th>
            <th>Von</th>
            <th>Bis</th>
            <th>Anlage</th>
            <th>Preis</th>
            <th></th>
          </tr>
          @for (sp of (data|async)?.SonderpreiseKunde; track sp) {
            <tr>
              <td>
                @if (sp.active) {
                  <div style="background-color: green; border-radius: 50%; height: 10px; width: 10px; cursor: help" matTooltip="Aktiv"></div>
                }
                @if (sp.inFuture) {
                  <div style="background-color: lightblue; border-radius: 50%; height: 10px; width: 10px; cursor: help" matTooltip="In Zukunft"></div>
                }
                @if (!sp.active && !sp.inFuture) {
                  <div style="background-color: lightgrey; border-radius: 50%; height: 10px; width: 10px; cursor: help" matTooltip="Abgelaufen"></div>
                }
              </td>
              <td>
                {{ sp.GueltigVon }}
              </td>
              <td>
                {{ sp.GueltigBis }}
              </td>
              <td>
                {{ sp.AnlageDatum }} - {{ sp.PreisErstellungBenutzer }}
                @if (sp.PreisText) {
                  <span>
                    ({{ sp.PreisText }})
                  </span>
                }
              </td>
              <td>
                {{ sp[(data|async)?.VerrechnungsPreiscodeKunde]|NiceNumber }}
              </td>
              <td>
                <button mat-icon-button matTooltip="Löschen" (click)="delete(sp)" [disabled]="!sp.active && !sp.inFuture">
                  <svg-icon>loeschen</svg-icon>
                </button>
              </td>
            </tr>
          }
          @if (!((data|async)?.SonderpreiseKunde) || (data|async)?.SonderpreiseKunde.length == 0) {
            <tr>
              <td colspan="6" style="text-align: center">
                - Keine Sonderpreise hinterlegt -
              </td>
            </tr>
          }
        </table>
        @if (!newEntry) {
          <div style="text-align: center; padding: 5px;">
            <button mat-flat-button (click)="startNew()">
              <svg-icon>plus</svg-icon>
              Neuen Preis anlegen
            </button>
          </div>
        }
        @if (newEntry) {
          <div style="margin-bottom: 5px; margin-top: 15px">
            <div class="mat-elevation-z1">
              <mat-toolbar>Neuer Sonderpreis</mat-toolbar>
              <div style="padding: 5px">
                <table class="table">
                  <tr>
                    <td style="border-top:0; height: 47px">
                      <strong>Gueltig von</strong>
                    </td>
                    <td style="border-top:0">
                      {{ newEntry.GueltigVon|date:'dd.MM.yyyy' }}
                    </td>
                    <td style="border-top:0">
                      <button (click)="dp1.open()" mat-raised-button>
                        <svg-icon>kalender</svg-icon>
                      </button>
                      <input [(ngModel)]="newEntry.GueltigVon" [matDatepicker]="dp1" required style="display: none">
                      <mat-datepicker #dp1
                        (closed)="updateGueltigBisIfNeeded()"
                        [touchUi]="true">
                      </mat-datepicker>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 47px">
                      <strong>Läuft ab</strong>
                    </td>
                    <td colspan="2">
                      <mat-checkbox [(ngModel)]="newHasGueltigBis" (change)="updateGueltigBisIfNeeded()"></mat-checkbox>
                    </td>
                  </tr>
                  @if (newHasGueltigBis) {
                    <tr>
                      <td style="height: 47px">
                        <strong>Gueltig bis</strong>
                      </td>
                      <td>
                        {{ newEntry.GueltigBis|date:'dd.MM.yyyy' }}
                      </td>
                      <td>
                        <button (click)="dp2.open()" mat-raised-button>
                          <svg-icon>kalender</svg-icon>
                        </button>
                        <input [(ngModel)]="newEntry.GueltigBis" [matDatepicker]="dp2" required style="display: none">
                        <mat-datepicker #dp2
                          [touchUi]="true">
                        </mat-datepicker>
                      </td>
                    </tr>
                  }
                  <tr>
                    <td style="height: 47px">
                      <strong>Preis</strong>
                    </td>
                    <td colspan="2">
                      <mat-form-field appearance="outline">
                        <input matInput type="number" [(ngModel)]="newEntryPrice" required>
                      </mat-form-field>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 47px">
                      <strong>Notiz/Info</strong>
                    </td>
                    <td colspan="2">
                      <mat-form-field appearance="outline">
                        <input matInput [(ngModel)]="newEntry.PreisText" maxlength="250">
                      </mat-form-field>
                    </td>
                  </tr>
                </table>
                <hr>
                  <div style="padding: 5px; text-align: center">
                    <button mat-flat-button (click)="saveNew()" style="margin-right: 5px">
                      <svg-icon>speichern</svg-icon> Speichern
                    </button>
                    <button mat-raised-button (click)="cancelNew()" color="warn">
                      <svg-icon>abbrechen</svg-icon> Abbrechen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
